export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'boltHome' */ 'components/bolt/home/home') },
	'termsAndPrivacy': { id: 'termsAndPrivacy', page: 'text', getter: () => import(/* webpackChunkName: 'termsAndPrivacy' */ 'components/bolt/text/text') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "boltSynopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' },
	{ id: 'boltWatchMore', getter: () => import(/* webpackChunkName: "boltWatchMore" */ 'components/bolt/watchMore/watchMore'), component: 'watchMore' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
